// removed by extract-text-webpack-plugin
module.exports = {"footer":"_3FbG1T7DHE2_OkC4ULls66","boxLogo":"_3_a8TAzqmJ80dE-vHnQGss","logo":"_1TwouPP2WYJ2ue-CXgpZ3n","icons":"_3YvXwPcyJO1g_rZZt_vnGr","icon":"_1aIZsJP6T0vGAKNNoHyOoF","iconlove":"_1_XsBCwJuV_nT1rBGf40v","linksgroup":"dB_rmDgfgaiILrP8eIubG","titlemenu":"_1AgpEpfsfVf-82fLA5stnc","spacer":"AOwFjPfcjgmzi_1m7JIWn"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Footer/style.css
// module id = 341
// module chunks = 37